import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSaveForm } from '@/shared/lib/useSaveForm';
import { FormField } from '@/shared/ui/FormField';
import { ModalDialog } from '@/shared/ui/ModalDialog';
import { assignOperator } from './api';

const FIELDS = [
  { key: 'name', label: 'Имя', placeholder: 'Имя' },
  { key: 'phone', label: 'Телефон', placeholder: 'Телефон' },
  { key: 'email', label: 'Email', placeholder: 'example@gmail.com' },
] as const;

const emptyForm = { name: '', phone: '', email: '' };

export const AssignOperatorModal = ({ onClose }: { onClose: () => void }) => {
  const queryClient = useQueryClient();
  const [form, setForm] = useState(emptyForm);

  const { errors, clearErrors, save, isPending } = useSaveForm(assignOperator, () => {
    void queryClient.invalidateQueries({ queryKey: ['callcenter-operators'] });
    onClose();
  });

  return (
    <ModalDialog title="Прикрепить нового сотрудника" onClose={onClose} isSaving={isPending} onSave={() => save(form)}>
      {FIELDS.map(({ key, label, placeholder }) => (
        <FormField key={key} label={label} errors={errors[key]}>
          <input
            className="form-control input-sm"
            placeholder={placeholder}
            value={form[key]}
            onChange={(e) => {
              setForm((prev) => ({ ...prev, [key]: e.target.value }));
              clearErrors(key);
            }}
          />
        </FormField>
      ))}
      {errors.common && <p className="text-red">{errors.common[0]}</p>}
    </ModalDialog>
  );
};
